import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryVendorListResponse, IInventoryVendorListResponseData } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryVendorListAPI = () => { 
  const [vendorList, setVendorList] = useState<IInventoryVendorListResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (query: string = "") => {
      dispatch(
        setLoading({
          key: "isInventoryVendorListLoadingInProgess",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const searchKeywordParam = query ? `search/?search=${query}` : "";
        await axios
          .get(`${INVENTORY_MODULE?.VENDOR_LIST?.baseURL}${searchKeywordParam} ` , {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryVendorListResponse>) => {
            dispatch(
              setLoading({
                key: "isInventoryVendorListLoadingInProgess",
                status: false,
              }),
            );
            if (res.data.status === true) {
              setVendorList(res.data.data);
            } else {
              setVendorList([]);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setVendorList([]);
            dispatch(
              setLoading({
                key: "isInventoryVendorListLoadingInProgess",
                status: false,
              }),
            );

            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { vendorList, execute };
};
